import React from 'react';
import { Card, Row, Col, Button } from 'reactstrap';

function EmployeeOffboardingActiveWork({ selectedPerson, header, onBack, onStartTransfer }) {
  const activeCounts = {
    tasks: selectedPerson.taskCount || 0,
    workflows: selectedPerson.workflowCount || 0,
    tickets: selectedPerson.ticketCount || 0,
  };
  const activeTotal = activeCounts.tasks + activeCounts.workflows + activeCounts.tickets;

  return (
    <>
      {header("Employee Offboarding", null, onBack)}
      <Row>
        <Col md={4} className='mb-3 mb-md-0'>
          <Card className='card-of-problemarea p-4 h-100'>
            <div className='eo-avatar'>{selectedPerson.initials}</div>
            <h5 className='eo-name mb-1'>{selectedPerson.name}</h5>
            <div className='eo-muted'>{selectedPerson.role}</div>
            <div className='eo-muted'>{selectedPerson.email}</div>
            <hr />
            <div className='eo-metric'><span>Tasks Not Signed Off</span><strong>{activeCounts.tasks}</strong></div>
            <div className='eo-metric'><span>Workflows Not Signed Off</span><strong>{activeCounts.workflows}</strong></div>
            <div className='eo-metric'><span>Tickets Not Closed</span><strong>{activeCounts.tickets}</strong></div>
            <div className='eo-metric'><span>Total Active Work</span><strong>{activeTotal}</strong></div>
            <div className='mt-4'>
              <b className='eo-small-title'>Offboarding Process</b>
              {["Review Work", "Transfer Work", "Store Role Mapping", "Deactivate"].map((s, i) => (
                <div className='eo-step' key={s}>
                  <span className={`eo-stepdot ${i === 0 ? 'eo-stepdone' : ''}`}>{i + 1}</span> {s}
                </div>
              ))}
            </div>
          </Card>
        </Col>
        <Col md={8}>
          <Card className='card-of-problemarea p-4 h-100'>
            <Row>
              <Col md={12}>
                <h5 className='eo-title'>Active Work</h5>
              </Col>
            </Row>
            <div className="border p-3 eo-status-row">
              <Row className="mx-n2">
                <Col md={4} className="px-2">
                  <div className="notification-status-box">
                    <h5 className="proactive-tasks"><b>Open Tasks</b></h5>
                    <h4 className="proactive-tasks"><b>{activeCounts.tasks}</b></h4>
                  </div>
                </Col>
                <Col md={4} className="px-2">
                  <div className="notification-status-box">
                    <h5 className="proactive-notifications"><b>Open Workflows</b></h5>
                    <h4 className="proactive-notifications"><b>{activeCounts.workflows}</b></h4>
                  </div>
                </Col>
                <Col md={4} className="px-2">
                  <div className="notification-status-box">
                    <h5 className="proactive-tickets"><b>Open Tickets</b></h5>
                    <h4 className="proactive-tickets"><b>{activeCounts.tickets}</b></h4>
                  </div>
                </Col>
              </Row>
            </div>
            <Row className='eo-footer-actions pt-3 m-0'>
              <Col md={12} className='text-right p-0'>
                <Button className='btn-background-color' onClick={onStartTransfer}>Start Work Transfer</Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default EmployeeOffboardingActiveWork;
